module.exports = __webpack_public_path__ + "img/terroir-charcoal-1-mobile.e1ef2b78.jpg";